export interface PossibleTypesResultData {
  possibleTypes: {
    [key: string]: string[];
  };
}
const result: PossibleTypesResultData = {
  possibleTypes: {
    Actor: ['APIToken', 'User'],
    AlertActivityHistoryRecordContent: [
      'AlertActivityHistoryAssigneeChange',
      'AlertActivityHistoryCommentAdded',
      'AlertActivityHistoryContextTagsChange',
      'AlertActivityHistoryQualityChange',
      'AlertActivityHistorySlackbotBoomerang',
      'AlertActivityHistoryStatusChange',
    ],
    AlertOrigin: [
      'AlertOriginPolicy',
      'AlertOriginReplayedRule',
      'AlertOriginRule',
      'AlertOriginSystemError',
      'DeletedDetection',
      'Detection',
      'SystemError',
    ],
    CommentEntity: ['Alert'],
    DatalakeSchemaEntity: [
      'DatalakeSchemaColumnEntity',
      'DatalakeSchemaDatalakeEntity',
      'DatalakeSchemaPropertyEntity',
      'DatalakeSchemaTableEntity',
    ],
    DetectionReportEntry: ['MitreReportEntry', 'StandardReportEntry'],
    GithubLogSourceCredentialsConfig: ['GithubLogSourceOAuth2Config', 'GithubLogSourcePatConfig'],
    GsuiteCredentialsConfig: [
      'GsuiteOAuth2Config',
      'GsuiteServiceAccountConfig',
      'GsuiteWorkloadIdentityFederationConfig',
    ],
    InternalDetection: ['CorrelationRule', 'Policy', 'Rule'],
    Job: [
      'BulkUploadJob',
      'GenerateSchemaFromSqlJob',
      'HoldingTankInferJob',
      'HoldingTankTestJob',
      'LookupImportDataJob',
      'LookupSyncJob',
      'ReclassifySourceAlarmJob',
      'SaveLookupJob',
      'SummarizeDataLakeQueryJob',
      'UpdateAlertStatusByFilterJob',
      'UpdateAllCatalogItemsJob',
    ],
    LogIntegration: [
      'AmazonSecurityLakeLogIntegration',
      'AzureBlobSourceIntegration',
      'AzureEventHubSourceIntegration',
      'CloudWatchLogIntegration',
      'EventBridgeIntegration',
      'GcpPubSubLogSourceIntegration',
      'GcsLogSourceIntegration',
      'HttpLogSourceIntegration',
      'LogForwarderLogSourceIntegration',
      'LogPullingIntegration',
      'OTLPLogSourceIntegration',
      'S3LogIntegration',
      'SqsLogSourceIntegration',
    ],
    LookupIntegration: ['EnrichmentIntegration', 'LogPullingIntegration'],
    SystemErrorRelatedEntity: [
      'AmazonSecurityLakeLogIntegration',
      'AzureEventHubSourceIntegration',
      'CloudWatchLogIntegration',
      'CorrelationRule',
      'Destination',
      'EnrichmentIntegration',
      'EventBridgeIntegration',
      'GcpPubSubLogSourceIntegration',
      'GcsLogSourceIntegration',
      'HttpLogSourceIntegration',
      'LogForwarderLogSourceIntegration',
      'LogPullingIntegration',
      'OTLPLogSourceIntegration',
      'Rule',
      'S3LogIntegration',
      'SqsLogSourceIntegration',
    ],
    TestRecord: ['TestDetectionRecord', 'TestPolicyRecord'],
    ZendeskLogSourceCredentialsConfig: [
      'ZendeskLogSourceApiConfig',
      'ZendeskLogSourceBasicConfig',
      'ZendeskLogSourceOAuth2Config',
    ],
  },
};
export default result;
